const AbstractVerifoneRequestRecord = require('./AbstractVerifoneRequestRecord');

/**
 * The WINSTATE messages allows the system to control the status of the [POS Client] window.
 */
class VerifoneWinStateRequestRecord extends AbstractVerifoneRequestRecord {
    /**
     * @param {number} state
     */
    constructor(state) {
        super();

        /**
         * 0 Normal
         * 1 Minimised
         * 2 Maximised
         */
        this.state = state;
    }

    toArray() {
        return [
            'WINSTATE',
            this.state,
        ];
    }
}

module.exports = VerifoneWinStateRequestRecord;
